import axios from 'axios'
import config from '@/config.js'
import exportConvert from '@/store/export.convert.js'
import {
  getStatic,
  getStaticDetail,
  readOnlyError,
  staticKey,
} from '@/services/data-source.js'
import { normalizeDocumentDetails } from '@/services/document-details.js'

const API_URL = config.apiUrl

function validatedXml(xml) {
  const parsed = new window.DOMParser().parseFromString(xml, 'application/xml')
  if (parsed.getElementsByTagName('parsererror').length) {
    throw new Error('The exported XML is not well-formed')
  }
  return xml
}

const state = {
  // documentList: [],
  document: null
}

const mutations = {
  // setDocumentList(state, payload) {
  //   state.documentList = payload;
  // },
  setDocument(state, document) {
    state.document = document;
  }
}

const getters = {
}

const actions = {
  async loadDocument({ commit }, data){
    const response = config.staticData
      ? await getStaticDetail('document', data.documentId)
      : await axios.post(`${API_URL}/document/${data.documentId}`, data)
    const document = config.staticData
      ? normalizeDocumentDetails(
          response.data,
          await exportConvert.convert("document.details", response.data)
        )
      : response.data
    commit('setDocument', document)
    return document
  },
  getElementDetails(_, data){
    return new Promise((resolve) => {
      axios
        .get(`${API_URL}/document/${data.documentId}/element-content/${data.elementType}/${data.elementNum}`)
        .then(r => r.data)
        .then(content => {
          resolve(content)
        })
    })
  },
  async getXML({ state }, data){
    if (config.staticData) {
      const documents = await Promise.all(data.docIds.map(async documentId => {
        if (state.document && String(state.document.id) === String(documentId)) {
          return state.document
        }
        const response = await getStaticDetail('document', documentId)
        return exportConvert.convert('document.details', response.data)
      }))
      const xmlDocuments = documents.map((document, index) => {
        const xml = String(document.originalXml || '').replace(/^\uFEFF/, '').trim()
        if (!xml) {
          throw new Error(`XML is unavailable for document ${data.docIds[index]}`)
        }
        return xml.replace(/^\s*<\?xml[^>]*>\s*/i, '')
      })
      if (xmlDocuments.length === 1) {
        return validatedXml(
          `<?xml version="1.0" encoding="UTF-8"?>\n${xmlDocuments[0]}`
        )
      }
      const body = xmlDocuments.join('\n')
      return validatedXml(
        `<?xml version="1.0" encoding="UTF-8"?>\n<corpus>${body}</corpus>`
      )
    }
    // let url = config.editable ? `${API_URL}/document/${documentId}/xml` : `${API_URL_CLIENTSIDE}/document/${documentId.slice(0, 2)}/${documentId}.xml` // TODO: fix this for new POST-structure also for public interface
    return new Promise((resolve) => {
      axios
        .post(`${API_URL}/document/xml`, data)
        .then(r => r.data)
        .then(content => {
          resolve(content)
        })
    })
  },
  getPDF(_, data){
    if (config.staticData) {
      return readOnlyError('PDF/LaTeX generation')
    }
    return new Promise((resolve) => {
      axios
        .post(`${API_URL}/document/pdf`, data, { responseType: 'blob'})
        .then((response) => {
          const blob = new Blob([response.data], { type: 'application/pdf' })
          resolve(blob)
        })
        .catch(async (err) => {
            const text = await err.response.data.text()
            const json = JSON.parse(text)
            this.dispatch('addNotification', {
              type: 'danger',
              text: json.message || 'could not compile PDF'
            })
        })
    })
  },
  lockDocument(_, data){
    if (!config.editable) {
      return readOnlyError('Locking a document')
    }
    return new Promise((resolve) => {
      axios
        .post(`${API_URL}/document/${data.documentId}/lock`, data)
        .then(r => r.data)
        .then(content => {
          resolve(content)
        })
    })
  },
  saveDocument(_, data){
    if (!config.editable) {
      return readOnlyError('Saving a document')
    }
    return new Promise((resolve) => {
      axios
        .post(`${API_URL}/document/${data.document.id}/save`, data)
        .then(response => {
          // this.dispatch('addNotification', {
          //   type: 'success',
          //   text: `Document saved`
          // })
          resolve(response)
        })
        .catch(() => {
          this.dispatch('addNotification', {
            type: 'danger',
            text: `Something went wrong`
          })
        })
    })
  },
  deleteDocument(_, document){
    if (!config.editable) {
      return readOnlyError('Deleting a document')
    }
    return new Promise((resolve) => {
      axios
        .delete(`${API_URL}/document/${document.id}`)
        .then(response => {
          this.dispatch('addNotification', {
            type: 'success',
            text: `Document deleted`
          })
          resolve(response)
        })
        .catch(() => {
          this.dispatch('addNotification', {
            type: 'danger',
            text: `Something went wrong`
          })
        })
    })
  },
  getVirtualDivs(_, codiNr){
    if (config.staticData) {
      return getStatic(`parallel/${staticKey(codiNr)}.json`).then(response => {
        const data = Object.values(response.data.parallel_divs || {})
          .map(item => item.alignment_unit)
          .sort((a, b) => a.position - b.position)
        return {data}
      })
    }
    return new Promise((resolve) => {
      axios
        .get(`${API_URL}/parallel/virtual_divs/${codiNr}`)
        .then(response => {
          resolve(response)
        })
    })
  },
}

export default {
    state,
    getters,
    actions,
    mutations
}
